import { FlexBox } from '../../../components/atoms/FlexBox/FlexBox';
import { Text } from '../../../components/atoms/Text/Text';
import { StyledProviderIcon } from './ProvidersList.styles';

type BranchHeaderProps = {
  iconUrl?: string;
  headerMessage: React.ReactNode;
};

export const BranchHeader = ({ iconUrl, headerMessage }: BranchHeaderProps) => (
  <FlexBox mb="normal" alignItems="center">
    {iconUrl && (
      <StyledProviderIcon
        height="40"
        width="40"
        src={iconUrl}
        alt=""
        role="presentation"
        loading="lazy"
        mr="xsmall"
      />
    )}
    <Text as="h2" size="small" bold>
      {headerMessage}
    </Text>
  </FlexBox>
);
